module.exports = __webpack_public_path__ + "site/img/logo.deef07ff.jpg";